import { createPreloadedModule } from './preloadedModule'

const pairPageModule = createPreloadedModule(() =>
  import('../pages/PairPage').then((module) => module.PairPageWithTradeSession)
)

export const loadPairPage = () => pairPageModule.load()
export const peekPairPage = () => pairPageModule.peek()
